export const transferZodErrors = (zodError) => {
  const transformedError = {};

  zodError?.issues?.forEach((issue) => {
    const key = issue.path[0] ?? "custom";
    if (!transformedError[key]) {
      transformedError[key] = [];
    }
    transformedError[key].push(issue.message);
  });

  return transformedError;
};
